import { Component, inject, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MarkerInfo, TeudaMarkerPopupData } from '@services/marker.service';
import { BehaviorSubject } from 'rxjs';

@Component({
	selector: 'app-mobilitydashbord-map-popup',
	templateUrl: './mobilitydashbord-map-popup.component.html',
	styleUrls: ['./mobilitydashbord-map-popup.component.scss'],
})
export class MobilitydashbordMapPopupComponent {
	private matDialogRef = inject(MatDialogRef<MobilitydashbordMapPopupComponent>);
	coordinates: MarkerInfo<TeudaMarkerPopupData>[] = this.data?.coordinates || [];

	shouldRecalculate$ = new BehaviorSubject<boolean>(false);
	isFullScreen$ = new BehaviorSubject<boolean>(false);

	constructor(@Inject(MAT_DIALOG_DATA) private data: { coordinates: MarkerInfo<TeudaMarkerPopupData>[] }) {}

	changeFullscreen(bool: boolean) {}

	onCloseClick() {
		this.matDialogRef.close();
	}
}
